import { toast } from "react-toastify";
import {fetchaddPeerConfigurationFailure, fetchaddPeerConfigurationSuccess } from "./reducer";
import {setSuccessMessage } from "../../toastMessage/action";
import {determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { getAllPeerConfiguration } from "../thunk";
import { PEER_CONFIGURATION_API } from "../../constants/constants";

export const addPeerConfiguration = (jsonObj, setLoading,setModalOpen) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${PEER_CONFIGURATION_API}`, 'POST', jsonObj).then((response) => {
        if (!response.error) {
            setLoading(false)
            setModalOpen(false)
            dispatch(fetchaddPeerConfigurationSuccess(response))
            dispatch(getAllPeerConfiguration(setLoading))
            dispatch(setSuccessMessage(true))
        }
        if (response.error) {
            dispatch(fetchaddPeerConfigurationFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}